import { useTranslation } from 'react-i18next';
import { Box, Button, Stack } from '@mui/material';
import { useForm, useFormState } from 'react-final-form';
import { useActionsButtons } from './hooks';
import { type HandleSubmit, SUBMIT_INTEGRATION_TYPE } from '../../../hooks';

type ActionButtonsProps = {
  onSubmit: HandleSubmit;
};

export const ActionButtons = ({ onSubmit }: ActionButtonsProps) => {
  const { t } = useTranslation(['settings', 'common']);
  const { values } = useFormState();
  const form = useForm();
  const { isAbleToSync, isConnected, handleTriggerIntegrationSync } = useActionsButtons();

  function handleSubmitWithValidation() {
    void form.submit();
    void (onSubmit?.[SUBMIT_INTEGRATION_TYPE.SAVE](values as unknown as any))();
  }

  return (
    <Box alignItems="flex-end" sx={{ display: 'flex', gap: 1 }}>
      <Stack direction="row" mt={{ xs: 10, sm: 0 }} spacing={2}>
        <Button variant="contained" onClick={handleTriggerIntegrationSync} disabled={!isAbleToSync}>
          {t('integrations.sync', { ns: 'settings' })}
        </Button>
      </Stack>
      <Stack direction="row" mt={{ xs: 10, sm: 0 }} spacing={2}>
        <Button variant="contained" onClick={handleSubmitWithValidation} disabled={!isConnected}>
          {t('save', { ns: 'common' })}
        </Button>
      </Stack>
    </Box>
  );
};
